import { useAuthStore } from '../stores/auth.store';
import type { SellerPermission } from '../auth/types';

export function useAuth() {
  const {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    hasPermission,
    logout,
  } = useAuthStore();

  return {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    hasPermission: (permission: SellerPermission) => hasPermission(permission),
    logout,
  };
}

export function useSession() {
  const { user, isAuthenticated, isLoading } = useAuthStore();

  return {
    data: isAuthenticated && user ? { user } : null,
    status: isLoading ? 'loading' : isAuthenticated ? 'authenticated' : 'unauthenticated',
  } as const;
}
